import React, { useState, useEffect, useCallback } from "react";
import {
  BarChart,
  XAxis,
  YAxis,
  Tooltip,
  Bar,
  CartesianGrid,
  ResponsiveContainer,
} from "recharts";
import dateFormat from "dateformat";
import RechartTooltip from "../RechartTooltip/RechartTooltip";
import { dataFormater, isMobile } from "../../utils/utils";
export default function RechartBar({
  getData,
  title,
}: {
  getData: () => void;
  title: string;
}) {
  const [data, setData] = useState(null);
  const [lastItem, setLastItem] = useState({});
  const [parentRect, setParentRect] = useState<any>();
  const [barPosData, setBarPosData] = useState<any>({});
  const loadData = useCallback(async (getData: () => void) => {
    let res: any = await getData();
    let data = [];
    if (res.data) {
      data = res.data.sort((item1: any, item2: any) => {
        if (item1.timestamp > item2.timestamp) {
          return 1;
        } else if (item1.timestamp < item2.timestamp) {
          return -1;
        } else {
          return 0;
        }
      });
      if (data.length > 0) {
        setLastItem(data[data.length - 1]);
      }
    }
    setData(
      data.map((d: any) => ({ time: d.timestamp, value: Number(d.value) }))
    );
  }, []);
  const tickFormatter = (tick: any) => {
    if (tick && tick !== "auto") {
      return dateFormat(new Date(tick * 1000), "mm-dd");
    } else {
      return "";
    }
  };

  useEffect(() => {
    const rect = document.querySelector(".graph")?.getBoundingClientRect();
    setParentRect(rect);
  }, []);
  useEffect(() => {
    if (getData) {
      loadData(getData);
    }
  }, [getData, loadData]);
  const interval = isMobile() ? 3 : 2;

  return data ? (
    <ResponsiveContainer height={300}>
      <BarChart height={300} width={parentRect.width} data={data}>
        <defs>
          <linearGradient id="colorArea" x1="0" y1="0" x2="0" y2="1">
            <stop offset="5%" stopColor="#3756CD" stopOpacity={0.85} />
            <stop offset="95%" stopColor="#3756CD" stopOpacity={0} />
          </linearGradient>
        </defs>

        <CartesianGrid vertical={false} strokeDasharray="9" stroke="#203B60" />
        <XAxis
          dataKey="time"
          axisLine={false}
          tickLine={false}
          tick={{ fill: "#fff", fontSize: "14" }}
          padding={{ left: 12, right: 12 }}
          tickFormatter={tickFormatter}
          interval={interval}
        />
        <YAxis
          dataKey="value"
          axisLine={false}
          tickLine={false}
          tickFormatter={(props) => dataFormater(props,2)}
          tick={{ fill: "#fff", fontSize: "14" }}
          padding={{ top: 25 }}
        />
        <Tooltip
          position={{ x: 16, y: -106 }}
          cursor={{
            y: barPosData.y - 10,
            height: barPosData.height + 10,
            stroke: "#fff",
            fill: "#3756CD",
            strokeWidth: 0,
            fillOpacity: 0.5,
          }}
          content={<RechartTooltip title={title} lastItem={lastItem} />}
        />
        <Bar
          type="monotone"
          dataKey="value"
          fill="#3756CD"
          radius={[10, 10, 0, 0]}
          fillOpacity={0.9}
          onMouseOver={(data) => {
            setBarPosData(data);
          }}
        />
      </BarChart>
    </ResponsiveContainer>
  ) : null;
}
